import { CommonModal } from '../CommonModal';

import { CommonModalType, ReturnComponentType } from 'common';
import { Roles } from 'enums';
import { useAppSelector } from 'hooks';
import { selectUserRole } from 'state';
import { Button } from 'ui-kit';
import './ModalSelectUser.scss';

type ModalAddUserType = CommonModalType & {
  openUserModal: (role: Roles) => void;
};

export const ModalSelectUser = ({
  showModal,
  setShowModal,
  openUserModal,
}: ModalAddUserType): ReturnComponentType => {
  const role = useAppSelector(selectUserRole);

  const closeAddUserModal = () => {
    setShowModal(false);
  };

  return (
    <CommonModal closeModal={closeAddUserModal} showModal={showModal}>
      <div className="ModalSelectUser">
        <header className="ModalSelectUser_Header">
          <div className="ModalSelectUser_Header_Title">Add User</div>
          {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
          <div onClick={closeAddUserModal} className="ModalSelectUser_Header_Close">
            &#10006;
          </div>
        </header>

        <div className="ModalSelectUser_Content">
          Please select which user you want to add
          <div className="ModalSelectUser_Content_ButtonGroup">
            {role === Roles.SUPER_ADMIN && (
              <Button
                className="ModalSelectUser_Content_ButtonGroup_Button"
                onClick={() => openUserModal(Roles.SUPER_ADMIN)}
              >
                Super Admin
              </Button>
            )}
            {role === Roles.COMPANY_ADMIN && (
              <Button
                className="ModalSelectUser_Content_ButtonGroup_Button"
                onClick={() => openUserModal(Roles.COMPANY_ADMIN)}
              >
                Company Admin
              </Button>
            )}
            {role === Roles.COMPANY_ADMIN && (
              <>
                <Button
                  className="ModalSelectUser_Content_ButtonGroup_Button"
                  onClick={() => openUserModal(Roles.LOCAL_ADMIN)}
                >
                  Local Admin
                </Button>
                <Button
                  className="ModalSelectUser_Content_ButtonGroup_Button"
                  onClick={() => openUserModal(Roles.INSPECTOR)}
                >
                  Inspector
                </Button>
              </>
            )}

            {role !== Roles.SUPER_ADMIN && (
              <>
                <Button
                  className="ModalSelectUser_Content_ButtonGroup_Button"
                  onClick={() => openUserModal(Roles.MANAGER)}
                >
                  Manager
                </Button>

                <Button
                  className="ModalSelectUser_Content_ButtonGroup_Button"
                  onClick={() => openUserModal(Roles.COMMUNITY_CUSTOMER)}
                >
                  Customer
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </CommonModal>
  );
};
